import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NotificationPopover from "@Shared/components/general/notification-popover";
import * as FieldComponents from "@Shared/components/sections/index";
import ResizableTextArea from "@Shared/components/inputs/resizable-textarea";
import { mapActions, mapState, mapGetters } from "vuex";
import { LOAD_LENDERS, LOAD_LENDER_SUBMISSION_NOTE, LOAD_VALIDATION_RULES_RESULT, PRINT_DOCUMENT_FORM, UPDATE_LENDER_NOTE } from "../../../../store/lender-submit-actions";
import { DOCUMENTS_FOR_APPLICATION } from "../../../../../documents/store/documents-getters";
import { LOAD_DOCUMENTS } from "../../../../../documents/store/documents-actions";
import { GET_LENDER_NAME_BY_MORTGAGE_TYPE } from "../../../../store/application-getters";
import Err from "../../../../../../../../routes/error";
import { showToast } from "@Shared/utils/constants";
import InlineLoader from "@Shared/components/general/inline-loader.vue";
import Field from "@Shared/components/sections/field.vue";
import { validationMixin } from "vuelidate";
import { required, requiredIf } from "vuelidate/lib/validators";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import CurrencyInput from "@Shared/components/inputs/currency-input.vue";
import RateInput from "@Shared/components/inputs/rate-input.vue";
import GenerateNotesModal from "./generate-notes-modal.vue";
import WidgetEventsMixin from "@Shared/@Utils/application-mixins/widget-events-mixin";
import IncidentMessage from "@Broker/@Modules/status-page/components/incident-message.vue";
import LenderSubmitMixin from "@Broker/@Modules/clients/applications/application/select-options/lender-submit-mixin";
import { openWidgetPopover } from "@Shared/@Utils/vue/directives/open-window-popover";
import { debounce, isEmpty, pull } from "lodash";
import vSelectField from "@Shared/components/form-elements/fields/v-select-field.vue";
import LanguageSelectorMixin from "@Shared/mixins/language-selector-mixin";
import { defineComponent } from "@vue/composition-api";
import { getLatestSubmissionPerLender } from "@Broker/@Modules/clients/applications/documents/store/document-utils";
export default defineComponent({
  name: "SubmissionBlock",
  components: _objectSpread(_objectSpread({}, FieldComponents), {}, {
    ResizableTextArea,
    NotificationPopover,
    InlineLoader,
    MaterialInput,
    CurrencyInput,
    RateInput,
    IncidentMessage,
    GenerateNotesModal,
    vSelectField,
    Field
  }),
  mixins: [WidgetEventsMixin, validationMixin, LenderSubmitMixin, LanguageSelectorMixin],
  validations() {
    return {
      localSubmissionData: {
        lenderType: {
          required
        },
        submissionMethod: {
          required
        },
        lenderName: {
          required: requiredIf(function () {
            return !this.showOtherLender;
          })
        },
        lenderProduct: {
          required: requiredIf(function () {
            return this.currentLenderProducts.length > 0;
          })
        },
        submissionLanguage: {
          required
        }
      },
      otherLenderName: {
        required: requiredIf(function () {
          return this.showOtherLender;
        })
      },
      dealType: {
        required
      }
    };
  },
  props: {
    totalLoanAmount: {
      type: null,
      required: true
    },
    netRate: {
      type: null,
      required: true
    },
    lineOfBusiness: {
      type: String,
      required: true
    },
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    },
    agentUsername: {
      type: String,
      required: true
    },
    mortgageType: {
      type: String,
      default: ""
    },
    missingFilogixDetails: {
      type: Boolean,
      required: true
    },
    accessRights: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      filogixDisabled: false,
      lenderSubmitOptions: {},
      localSubmissionData: {},
      loading: {
        lenders: false,
        note: false,
        validations: false
      },
      packageValidationsFetched: false,
      showOtherLender: false,
      otherLenderName: "",
      dismissSoftStopValidations: false,
      requestSubmissionConfirmationPending: false,
      documentsToLender: [],
      loadingOptions: false,
      lenderDocSubmissionDisclaimerAccepted: false,
      showButton: true
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapGetters("ApplicationStore", [GET_LENDER_NAME_BY_MORTGAGE_TYPE, "getSubmissionHistory"])), mapGetters("DocumentsStore", [DOCUMENTS_FOR_APPLICATION])), mapState("ApplicationStore", {
    dealType(state) {
      return state.lenderSubmissionData.dealType;
    },
    lenderNotes(state) {
      return state.lenderNotes;
    },
    lenders(state) {
      var _context;
      const lendersLista = state.lenders;
      if (isEmpty(lendersLista)) return lendersLista;

      // only lenders of selected type are to shown
      const lenderTypes = this.lenderTypeOptions;
      // if type is not in the types list then default is
      const defLenderType = lenderTypes[0].value; // this is "financial-institution"
      const selectedType = this.localSubmissionData.lenderType;
      const isDefSelectedType = selectedType == defLenderType;
      const lendersListb = _mapInstanceProperty(_context = _filterInstanceProperty(lendersLista).call(lendersLista, ({
        type
      }) => type === selectedType || isDefSelectedType && !_findInstanceProperty(lenderTypes).call(lenderTypes, t => t.value == type))).call(_context, l => {
        return {
          label: l.label,
          value: l.value,
          mtgProductId: l.mtgProductId,
          submitCreditReports: l.submitCreditReports,
          docMethod: l.docMethod
        };
      });
      if (this.localSubmissionData.submissionMethod === "manual") {
        lendersListb.unshift({
          label: this.$t("direct-to-lender.lenderSubmit.otherLender"),
          value: "other",
          mtgProductId: "",
          submitCreditReports: true,
          docMethod: "U"
        });
      }
      return lendersListb;
    },
    validationRulesResult(state) {
      return state.validationRulesResult.byId[this.applicationId] || {};
    }
  })), {}, {
    submissionMethodSelectOptions() {
      if (this.filogixDisabled) return [{
        label: this.$t("global.words.manual"),
        value: "manual"
      }];
      return this.submissionMethodOptions;
    },
    documents() {
      return _Object$values(this.DOCUMENTS_FOR_APPLICATION(this.applicationId).byId);
    },
    isLenderBlocked() {
      var _this$currentLender;
      return ((_this$currentLender = this.currentLender) == null ? void 0 : _this$currentLender.docMethod) == null;
    },
    submissionHistoryLength() {
      return this.getSubmissionHistory.allIds.length;
    },
    lastLenderSubmissionPerLender() {
      return getLatestSubmissionPerLender(this.getSubmissionHistory);
    },
    isAnyDocumentSent() {
      var _context2;
      return _findInstanceProperty(_context2 = _Object$values(this.lastLenderSubmissionPerLender)).call(_context2, elem => {
        var _elem$documentsSent;
        return ((_elem$documentsSent = elem.documentsSent) == null ? void 0 : _elem$documentsSent.length) > 0;
      });
    },
    docsToLenderMessage() {
      var _context3;
      if (!this.documents.length) {
        return this.$t("direct-to-lender.lenderSubmit.documentsNotUploaded");
      }
      if (!this.submissionData.lenderName) {
        return this.$t("direct-to-lender.lenderSubmit.selectLenderBeforeSelectDocuments");
      }
      const submissionToLender = _findInstanceProperty(_context3 = this.lastLenderSubmissionPerLender).call(_context3, ({
        lenderName
      }) => lenderName === this.submissionData.lenderName);
      if (submissionToLender != null && submissionToLender.documentsSent.length && this.documents.every(({
        documentId
      }) => {
        var _context4;
        return _includesInstanceProperty(_context4 = submissionToLender.documentsSent).call(_context4, documentId);
      })) {
        return this.$t("direct-to-lender.lenderSubmit.alreadySentAll");
      }
      return "";
    },
    submitButtonText() {
      return this.localSubmissionData.submissionMethod === "manual" ? this.$t("direct-to-lender.lenderSubmit.printApplication") : this.$t("global.words.submit");
    },
    submissionData() {
      const lenderName = this.showOtherLender ? this.otherLenderName : this.localSubmissionData.lenderName;
      return _objectSpread(_objectSpread({}, this.localSubmissionData), {}, {
        dealType: this.dealType,
        mortgageType: this.mortgageType,
        lenderName
      });
    },
    emptyValidationRulesResult() {
      const {
        businessErrors
      } = this.validationRulesResult;
      return isEmpty(businessErrors);
    },
    onlySoftStopValidations() {
      if (this.emptyValidationRulesResult) return false;
      return !this.validationRulesResult.businessErrors.some(({
        softStop
      }) => !softStop);
    },
    hasHardStopValidations() {
      if (this.emptyValidationRulesResult) return false;
      return !this.onlySoftStopValidations;
    },
    validationsPopoverType() {
      const invalidChecks = this.missingFilogixDetails || this.hasHardStopValidations || !this.validSubmissionDetailsForm;
      if (invalidChecks) return "error";
      if (this.onlySoftStopValidations) return "default";
      return "success";
    },
    validationStatus() {
      const invalidChecks = this.missingFilogixDetails || this.hasHardStopValidations || !this.packageValidationsFetched || !this.validSubmissionDetailsForm;
      if (invalidChecks) return "invalid";
      if (this.onlySoftStopValidations) return "soft";
      return "valid";
    },
    validButtonIcon() {
      const validMap = {
        invalid: "fa-times-circle text-danger",
        soft: "fa-exclamation-circle text-warning",
        valid: "fa-check-circle text-success"
      };
      return validMap[this.validationStatus];
    },
    lenderSubmitText() {
      if (this.accessRights.submitApplications == false) {
        return this.$t("direct-to-lender.lenderSubmit.insufficientPermissions");
      }
      if (this.missingFilogixDetails) return this.$t("direct-to-lender.lenderSubmit.inOrderToSubmit");
      if (!this.validSubmissionDetailsForm) return this.$t("direct-to-lender.lenderSubmit.invalidSubmissionDetails");
      if (this.lenderNoteTooLong) {
        return this.$t("direct-to-lender.lenderSubmit.reduceTheSizeOfYourNote");
      }
      const submitTextMap = {
        invalid: this.$t("direct-to-lender.lenderSubmit.submissionHasErrors"),
        soft: this.$t("direct-to-lender.lenderSubmit.submissionHasWarnings"),
        valid: this.$t("direct-to-lender.lenderSubmit.submissionIsValid")
      };
      return submitTextMap[this.validationStatus];
    },
    currentLender() {
      var _context5;
      return this.localSubmissionData.lenderName && _findInstanceProperty(_context5 = this.lenders).call(_context5, lender => this.localSubmissionData.lenderName === lender.value);
    },
    currentLenderProducts() {
      var _context6;
      if (this.showOtherLender) return [];
      return this.currentLender && _mapInstanceProperty(_context6 = this.currentLender.mtgProductId).call(_context6, product => ({
        label: this.$i18n.locale == "en-CA" ? product.name["en"] : product.name["fr"],
        value: product.value
      })) || [];
    },
    select2Options() {
      return {
        dropdownParent: "#lender-submit-form",
        closeOnSelect: true,
        language: {
          noResults() {
            return this.$t("direct-to-lender.lenderSubmit.emptyLenders");
          }
        }
      };
    },
    windowPopoverUrl() {
      const {
        agentUsername,
        clientUsername,
        applicationId
      } = this;
      return `#/widgets/applications/${applicationId}/client/${clientUsername}/agent/${agentUsername}/validation-rules`;
    },
    validSubmissionDetailsForm() {
      return !this.$v.$invalid;
    },
    lenderNoteTooLong() {
      return this.lenderNoteLength > 4000;
    },
    lenderNoteLength() {
      var _this$localSubmission, _this$localSubmission2;
      return (_this$localSubmission = (_this$localSubmission2 = this.localSubmissionData.lenderNote) == null ? void 0 : _this$localSubmission2.length) != null ? _this$localSubmission : 0;
    },
    validSubmissionDetails() {
      return this.validSubmissionDetailsForm && !this.missingFilogixDetails;
    },
    disableSubmit() {
      return !this.validSubmissionDetailsForm || this.hasHardStopValidations || this.missingFilogixDetails || this.loading.validations || !this.accessRights.submitApplications || this.accessRights.viewOnly || this.lenderNoteTooLong || this.documentSubmissionDisclaimerInvalid;
    },
    shouldShowDocsToLenderDisclaimer() {
      var _this$docsToLender$le, _this$docsToLender;
      return this.localSubmissionData.submissionMethod == "electronic" && !this.isLenderBlocked && ((_this$docsToLender$le = (_this$docsToLender = this.docsToLender) == null ? void 0 : _this$docsToLender.length) != null ? _this$docsToLender$le : 0) > 0;
    },
    documentSubmissionDisclaimerInvalid() {
      var _this$docsToLender$le2, _this$docsToLender2;
      if (this.localSubmissionData.submissionMethod == "electronic" && !this.isLenderBlocked && ((_this$docsToLender$le2 = (_this$docsToLender2 = this.docsToLender) == null ? void 0 : _this$docsToLender2.length) != null ? _this$docsToLender$le2 : 0) > 0) {
        return !this.lenderDocSubmissionDisclaimerAccepted;
      }
      return false;
    },
    isCurrentLenderAuthorized() {
      if (!this.currentLender) return true;
      return this.currentLender.submitCreditReports;
    },
    docsToLender() {
      return this.localSubmissionData.docsToLender;
    },
    language() {
      if (!this.locale) return "en";
      return this.locale === "en-CA" ? "en" : "fr";
    }
  }),
  watch: {
    totalLoanAmount: {
      immediate: true,
      handler(value, oldValue) {
        if (oldValue != value) {
          this.sendWidgetMessage("validation-rules", "pre-fetch");
          this.getLenderName();
          this.getLenderNote();
          this.syncWidgetSubmissionData();
        }
      }
    },
    submissionData: {
      deep: true,
      immediate: true,
      handler() {
        this.syncWidgetSubmissionData();
        if (this.validSubmissionDetailsForm) {
          this.packageValidationsFetched = true;
          this.loadValidationResults(_objectSpread(_objectSpread({}, this.submissionData), {}, {
            submissionPackage: true
          }));
        }
      }
    },
    "localSubmissionData.lenderNote": {
      handler: debounce(function (newLenderNote, oldLenderNote) {
        var _newLenderNote$length;
        if (newLenderNote !== oldLenderNote && ((_newLenderNote$length = newLenderNote == null ? void 0 : newLenderNote.length) != null ? _newLenderNote$length : 0) <= 4000) {
          this.UPDATE_LENDER_NOTE({
            applicationId: this.applicationId,
            clientUsername: this.clientUsername,
            lenderNote: newLenderNote
          });
        }
      }, 500, {
        leading: false,
        trailing: true
      })
    },
    filogixDisabled(val) {
      if (val) {
        this.localSubmissionData.submissionMethod = "manual";
      }
    },
    onlySoftStopValidations: {
      handler(val) {
        this.dismissSoftStopValidations = !val;
      },
      immediate: true
    }
  },
  async mounted() {
    var _context7, _context8;
    const {
      lenderTypeOptions,
      submissionLanguageOptions
    } = this;
    let lastLenderSubmission = _findInstanceProperty(_context7 = this.lastLenderSubmissionPerLender).call(_context7, el => el.lenderName === this.submissionData.lenderName);
    const lender = this.GET_LENDER_NAME_BY_MORTGAGE_TYPE({
      mortgageType: this.mortgageType,
      applicationId: this.applicationId
    });
    this.$set(this, "lenderSubmitOptions", {
      lenderTypeOptions,
      submissionLanguageOptions
    });
    this.$set(this, "localSubmissionData", {
      lenderType: lenderTypeOptions[0].value,
      submissionMethod: "electronic",
      lenderName: lender,
      lenderProduct: "",
      submissionLanguage: "english",
      lenderNote: null,
      docsToLender: []
    });
    this.$v.$touch();
    this.sendWidgetMessage("validation-rules", "pre-fetch");
    this.setCloseWidgetOnExit(false);
    this.getLenderName();
    this.packageValidationsFetched = this.validSubmissionDetailsForm;
    this.loading = _objectSpread(_objectSpread({}, this.loading), {}, {
      lenders: true,
      note: true
    });
    await this.LOAD_LENDERS({
      applicationId: this.applicationId
    }).then(() => {
      this.loading.lenders = false;
    });
    this.LOAD_LENDER_SUBMISSION_NOTE({
      clientUsername: this.clientUsername,
      applicationId: this.applicationId
    }).then(() => {
      this.loading.note = false;
      this.getLenderNote();
    });
    this.syncWidgetSubmissionData();
    await this.LOAD_DOCUMENTS({
      clientUsername: this.clientUsername,
      applicationId: this.applicationId
    });
    this.documentsToLender = isEmpty(this.documents) || this.documents.every(el => {
      var _lastLenderSubmission;
      return lastLenderSubmission == null ? void 0 : (_lastLenderSubmission = lastLenderSubmission.documentsSent) == null ? void 0 : _includesInstanceProperty(_lastLenderSubmission).call(_lastLenderSubmission, el.documentId);
    }) ? [] : _mapInstanceProperty(_context8 = this.documents).call(_context8, doc => {
      return {
        id: doc.documentId,
        label: `${doc.classificationType} - ${doc.fileName}`
      };
    });
  },
  async activated() {
    var _context9, _context0, _context1;
    this.loading.lenders = true;
    this.LOAD_LENDERS({
      applicationId: this.applicationId
    }).then(() => {
      this.loading.lenders = false;
    });

    //reload lender name
    this.localSubmissionData.lenderName = await this.GET_LENDER_NAME_BY_MORTGAGE_TYPE({
      mortgageType: this.mortgageType,
      applicationId: this.applicationId
    });
    const lastLenderSubmission = _findInstanceProperty(_context9 = this.lastLenderSubmissionPerLender).call(_context9, el => el.lenderName === this.localSubmissionData.lenderName);
    this.documentsSent = isEmpty(lastLenderSubmission) ? [] : lastLenderSubmission.documentsSent;
    if (!isEmpty(this.documentsSent)) await this.LOAD_DOCUMENTS({
      clientUsername: this.clientUsername,
      applicationId: this.applicationId
    });
    this.documentsToLender = _mapInstanceProperty(_context0 = _filterInstanceProperty(_context1 = this.documents).call(_context1, doc => {
      var _context10;
      return isEmpty(this.documentsSent) || !_includesInstanceProperty(_context10 = this.documentsSent).call(_context10, doc.documentId);
    })).call(_context0, doc => ({
      id: doc.documentId,
      label: `${doc.classificationType} - ${doc.fileName}`
    }));

    //reload submit button
    this.loading.validations = true;
    try {
      await this.LOAD_VALIDATION_RULES_RESULT({
        clientUsername: this.clientUsername,
        applicationId: this.applicationId,
        submissionData: this.submissionData
      });
    } finally {
      this.loading.validations = false;
    }
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("ApplicationStore", [LOAD_LENDERS, LOAD_VALIDATION_RULES_RESULT, PRINT_DOCUMENT_FORM, UPDATE_LENDER_NOTE, LOAD_LENDER_SUBMISSION_NOTE])), mapActions("DocumentsStore", [LOAD_DOCUMENTS])), {}, {
    async handleSubmit() {
      if (this.disableSubmit) return;
      if (!this.submissionData.dealType) return showToast("error", "selectAppTypeBeforeSubmit");
      if (!this.dismissSoftStopValidations) return this.requestSubmitConfirmation();
      this.$emit("submit", _objectSpread(_objectSpread({}, this.submissionData), {}, {
        ignoreSoftError: this.onlySoftStopValidations
      }));
      this.localSubmissionData.lenderName = "";
      this.localSubmissionData.docsToLender = [];
      this.documentsToLender = [];
      return;
    },
    requestSubmitConfirmation() {
      this.requestSubmissionConfirmationPending = true;
      openWidgetPopover(this, {
        url: this.windowPopoverUrl,
        width: 900,
        height: 600
      });
      this.syncWidgetSubmissionData();
    },
    async handlePrintApplication() {
      const button = $(".print-mortgage-summary");
      try {
        button.animateButton().animate("start");
        const forms = [{
          type: "mortgageSummary",
          province: "FEDERAL",
          mortgage: this.mortgageType
        }];
        const payload = {
          clientUsername: this.clientUsername,
          applicationId: this.applicationId,
          forms
        };
        await this.PRINT_DOCUMENT_FORM(payload);
        await button.animateButton().animate("finish");
      } catch (e) {
        Err.handle(e);
        button.animateButton().animate("finish", "failed");
      }
    },
    getLenderName() {
      this.localSubmissionData.lenderName = this.GET_LENDER_NAME_BY_MORTGAGE_TYPE({
        mortgageType: this.mortgageType,
        applicationId: this.applicationId
      });
    },
    getLenderNote() {
      this.localSubmissionData.lenderNote = this.lenderNotes[this.applicationId] || null;
    },
    clearNote() {
      this.localSubmissionData.lenderNote = null;
    },
    async updateLenderName(obj) {
      var _context11, _context12, _context13, _context14;
      const id = obj.value;
      const lastLenderSubmission = _findInstanceProperty(_context11 = this.lastLenderSubmissionPerLender).call(_context11, s => s.lenderName == id);
      this.loadingOptions = true;
      this.documentsSent = isEmpty(lastLenderSubmission) ? [] : lastLenderSubmission.documentsSent;
      if (!isEmpty(this.documentsSent)) await this.LOAD_DOCUMENTS({
        clientUsername: this.clientUsername,
        applicationId: this.applicationId
      });
      // Display available documents per selected lender
      this.documentsToLender = isEmpty(this.documentsSent) ? _mapInstanceProperty(_context12 = this.documents).call(_context12, doc => {
        return {
          id: doc.documentId,
          label: `${doc.classificationType} - ${doc.fileName}`
        };
      }) : _mapInstanceProperty(_context13 = _filterInstanceProperty(_context14 = this.documents).call(_context14, ad => {
        var _context15;
        return !_includesInstanceProperty(_context15 = this.documentsSent).call(_context15, ad.documentId);
      })).call(_context13, doc => {
        return {
          id: doc.documentId,
          label: `${doc.classificationType} - ${doc.fileName}`
        };
      });
      if (id === "other") {
        this.showOtherLender = true;
        this.localSubmissionData.lenderName = id;
        this.loadingOptions = false;
        return;
      }
      this.showOtherLender = false;
      this.localSubmissionData.lenderName = id;
      this.$emit("update-lender-name", this.localSubmissionData.lenderName);
      this.loadingOptions = false;
    },
    clearLenderName() {
      this.localSubmissionData.lenderName = "";
      if (this.showOtherLender) {
        this.showOtherLender = false;
      }
    },
    clearLenderType() {
      this.localSubmissionData.lenderType = "";
    },
    clearSubmissionMethod() {
      this.localSubmissionData.submissionMethod = "";
    },
    formatData(data) {
      return data && _mapInstanceProperty(data).call(data, ({
        label,
        value
      }) => {
        return {
          text: label,
          id: value
        };
      });
    },
    async loadValidationResults(submissionData) {
      //We can't load validations if there are missing filogix details
      //backend will throw error, skipping since user cannot do anything else here
      if (this.missingFilogixDetails) return;
      this.loading.validations = true;
      try {
        await this.LOAD_VALIDATION_RULES_RESULT({
          clientUsername: this.clientUsername,
          applicationId: this.applicationId,
          submissionData
        });
      } finally {
        this.loading.validations = false;
      }
    },
    syncWidgetSubmissionData() {
      this.sendWidgetMessage("validation-rules", "sync", {
        submissionData: _objectSpread(_objectSpread({}, this.submissionData), {}, {
          submissionPackage: this.validSubmissionDetailsForm
        }),
        validSubmissionDetails: this.validSubmissionDetails,
        requestSubmissionConfirmationPending: this.requestSubmissionConfirmationPending
      });
    },
    handleMessage({
      type,
      target
    }) {
      if (target !== "validation-rules") return;
      if (type === "request-sync") {
        return this.syncWidgetSubmissionData();
      }
      if (type === "dismiss-validations") {
        return this.handleDismissValidations();
      }
    },
    handleIncidentUpdate(hasIncident) {
      this.filogixDisabled = hasIncident;
    },
    async handleDismissValidations() {
      this.requestSubmissionConfirmationPending = false;
      this.dismissSoftStopValidations = true;
      this.handleSubmit();
    },
    handleAutoComposeLenderNoteClick() {
      this.$refs.generateNotesModal.onOpen();
      this.$refs.generateNotesModal.showModal();
    },
    handleAutoComposedNote(note) {
      var _this$localSubmission3;
      this.localSubmissionData.lenderNote = (_this$localSubmission3 = this.localSubmissionData.lenderNote) != null && _this$localSubmission3.length ? this.localSubmissionData.lenderNote + "\n\n" + note : note;
    },
    handleSelectSubmission(val) {
      this.localSubmissionData.submissionMethod = val.value;
      if (val.value === "manual") {
        this.localSubmissionData.docsToLender = [];
      }
    },
    handleSelectDocument(document) {
      if (document.id === "all") {
        this.localSubmissionData.docsToLender = [];
        this.documentsToLender.forEach(doc => this.localSubmissionData.docsToLender.push(doc.id));
      } else {
        this.localSubmissionData.docsToLender.push(document.id);
      }
    },
    handleDeselectDocument(document) {
      var _context16;
      if (document.id === "all") {
        this.localSubmissionData.docsToLender = [];
      } else if (_includesInstanceProperty(_context16 = this.localSubmissionData.docsToLender).call(_context16, "all")) {
        var _context17;
        this.localSubmissionData.docsToLender = _filterInstanceProperty(_context17 = this.localSubmissionData.docsToLender).call(_context17, doc => doc !== "all" && doc !== document.id);
      } else {
        this.localSubmissionData.docsToLender = pull(this.localSubmissionData.docsToLender, document.id);
      }
      this.localSubmissionData.docsToLender = [...this.localSubmissionData.docsToLender];
    }
  })
});